module.exports = __webpack_public_path__ + "static/working-advisor-hero-tablet.aff3fb66.webp";